// 028C-1 — Curva de Crecimiento Niño de 5 a 9 años (corrección de
// numeración, ver PLAN.md Serie 028 — antes "028A4", código incorrecto).
import { crearFormularioCurvaCrecimiento } from './curvaCrecimiento';

export const Formulario028C1 = crearFormularioCurvaCrecimiento({ claveI18n: 'f028c1', curvasPdf: 'oms5a19' });
